function isExternalLink (anchor) {
  if (anchor.href.startsWith('mailto:') || anchor.href.startsWith('tel:')) {
    return false;
  }

  return anchor.hostname !== window.location.hostname;
}

export default function externalLinks () {
  const anchors = document.querySelectorAll('a');
  for (let anchor of anchors) {
    if (isExternalLink(anchor)) {
      anchor.setAttribute('target', '_blank');
    }
  }
}
